/* eslint-disable  react/display-name*/
import { Button, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import Grid from "@mui/material/Grid";
import db from "../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceCrud from "./ServiceCrud.jsx";
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function ServiceList(props) {
  const [data, setData] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);

  const { t } = useTranslation();
  const translate = t;

  useEffect(() => {
    loadData();
  }, []);

  function addProduct() {
    biRef.child.showServiceCrudWindow(null);
  }

  function onEditClicked(tableMeta, updateValue, value) {
    biRef.child.showServiceCrudWindow(
      tableMeta.tableData[tableMeta.currentTableData[tableMeta.rowIndex].index]
        .id
    );
  }

  async function loadData() {
    //loadByRest();
    loaadByDB();
  }
  async function loadByRest() {}
  async function loaadByDB() {
    db.product.toArray(function (data) {
      let dt = [];
      for (let d of data) {
        if (d.productType != null && d.productType == "S") {
          console.log(">>>", d);

          dt.push(d);
        }
      }
      setData(dt);
    });
    let dbData = await db.config.where("name").equals("UNIT_TYPES").toArray();
    setUnitTypeOptions(JSON.parse(dbData[0].configTxt));
  }

  const options = {
    filterType: "dropdown",
    download: false,
    filter: false,
    rowHover: true,
    search: false,
    refresh: false,

    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 225,
    rowsPerPage: Math.round((getWindowDimensions().height - 345) / 25),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 345) / 25),
      10,
      15,
      50,
      100,
    ],
    print: false,
    customToolbar: () => {
      return (
        <React.Fragment>
          {!props.readOnly && props.context.store.shopType != "BRANCH" && (
            <Tooltip title={translate("Add New Service")}>
              <IconButton size="small" color="secondary" onClick={addProduct}>
                <AddIcon />
              </IconButton>
            </Tooltip>
          )}
        </React.Fragment>
      );
    },
  };

  const columns = [
    {
      name: "code",
      label: translate("Code"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "name",
      label: translate("Service Name"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "category1Name",
      label: translate("Department"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "left",
          "@media only screen and (max-width: 600px)": {},
        }),
        setCellProps: () => ({ align: "left" }),
        customBodyRender: (value, tableMeta, updateValue) =>
          tableMeta.tableData[
            tableMeta.currentTableData[tableMeta.rowIndex].index
          ].deptBean.name,
      },
    },

    {
      name: "price",
      label: translate("Service Charge"),
      options: {
        filter: false,
        sort: true,
        display: false,
        customBodyRender: (value, tableMeta, updateValue) =>
          tableMeta.tableData[
            tableMeta.currentTableData[tableMeta.rowIndex].index
          ].productPricingBeanList[0].price,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({
          align: "right",
        }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={{
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            }}
          >
            {props.context.privileges.service_edit
              ? translate("Edit")
              : translate("view")}
          </Button>
        ),
      },
    },
  ];

  async function productListRefresh() {
    for (let i = 0; i < 3; i++) {
      await sleep(3000);
      loadData();
    }
  }
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  var biRef = {};

  return (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={translate("Service List")}
            data={data}
            columns={columns}
            options={options}
          />
        </div>
      </Grid>
      <ServiceCrud
        context={props.context}
        unitTypeOptions={unitTypeOptions}
        biRef={biRef}
        showMessage={props.showMessage}
        onRefresh={productListRefresh}
      ></ServiceCrud>
    </Grid>
  );
}
